// Atstumas tarp dviejų taškų kilometrais (Haversine formulė)
export function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLng = ((lng2 - lng1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2)
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

// Ar vieta atvira dabar pagal darbo_laikas eilutę (pvz. "09:00 - 21:00")
export function arAtviraDabar(darboLaikas) {
  if (!darboLaikas) return false
  const m = darboLaikas.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/)
  if (!m) return false
  const dabar = new Date()
  const dabarMin = dabar.getHours() * 60 + dabar.getMinutes()
  const atidaro = parseInt(m[1]) * 60 + parseInt(m[2])
  const uzdaro = parseInt(m[3]) * 60 + parseInt(m[4])
  return dabarMin >= atidaro && dabarMin < uzdaro
}
